import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideGlobalAlert } from "slices/app/appSlice";
import {
  Alert,
  alertTypes,
} from "@visiblethread/react-components/dist/components/Alert";

export const AlertsHolder = () => {
  const { inline, global } = useSelector((state) => state.app.alerts);
  const dispatch = useDispatch();
  const closeGlobalAlert = () => {
    dispatch(hideGlobalAlert());
  };
  return (
    <>
      {inline && (
        <Alert
          type={alertTypes.inline}
          variant={inline.variant}
          text={inline.text}
          hideCloseButton
        />
      )}
      {global && (
        <Alert
          type={alertTypes.global}
          variant={global.variant}
          text={global.text}
          autoDismissible
          dismissTimeout={global?.dismissTimeout || 5000}
          onClose={closeGlobalAlert}
        />
      )}
    </>
  );
};
